const pre = '/fisco-bcos/';

export default {
    path: '/fisco-bcos',
    title: 'FISCO BCOS',
    header: '',
    icon: 'md-link',
    children: [
        {
            path: `${pre}generator`,
            title: '链管理'
        },
        {
            path: `${pre}webase`,
            title: '区块链浏览器'
        },
        {
            path: `${pre}front`,
            title: '节点管理',
            hidden: true,
        },
        {
            path: `${pre}contract`,
            title: '合约管理',
            hidden: true,
        },
        {
            path: `${pre}block`,
            title: '区块管理',
            hidden: true,
        },
        {
            path: `${pre}transaction`,
            title: '交易管理',
            hidden: true,
        },
    ]
}
